import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

const SIZE_MAP = {
    sm: 22,
    md: 30,
    lg: 40,
};
interface CountBubbleProps {
    count: number;
    color?: string;
    backgroundColor?: string;
    size?: keyof typeof SIZE_MAP;
    className?: string;
}

export function CountBubble({
    count,
    color = Colors.white,
    backgroundColor = Colors.secondary,
    size = 'sm',
    className,
}: CountBubbleProps) {
    return (
        <Bubble color={color} backgroundColor={backgroundColor} size={size} className={className}>
            {count}
        </Bubble>
    );
}

const Bubble = styled('span')<{
    color: string;
    backgroundColor: string;
    size: keyof typeof SIZE_MAP;
}>(({ color, backgroundColor, size }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: SIZE_MAP[size],
    height: SIZE_MAP[size],
    padding: '0 6px',
    borderRadius: SIZE_MAP[size] / 2,
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: backgroundColor,
    color: color,
}));
